import FormPropertiesProvider from './FormPropertiesProvider';

const data = {
  __init__: [ 'formPropertiesProvider' ],
  formPropertiesProvider: [ 'type', FormPropertiesProvider ]
};

export default data;